import { Controller } from "stimulus";

export class DropdownMenuBaseController extends Controller {
  initialize() {
    this.clickOutsideHandler = this._handleOutsideClick.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler);
  }

  _handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.closeMenu();
    }
  }

  closeMenu() {}

  _deselectItems() {
    this.menuItemTargets.forEach((item) => {
      item.querySelector(".js-menu-option-check").classList.add("invisible");
      item.classList.remove("js-selected");
    });
  }

  _selectItem(target) {
    target.querySelector(".js-menu-option-check").classList.remove("invisible");
    target.classList.add("js-selected");
  }
}
